import { useEffect, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { Info } from "../../models/matriz/Info";
import { InputComponent } from "../../components/InputComponent";
import { FuncionarioService } from "../../service/ficha/FuncionarioService";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { useToken } from "../../components/useToken";
import { RadioButton } from "primereact/radiobutton";

export const Busqueda = ({ opcion, permss, toast, seleccion, filtro }) => {
    const generic = new GenericComponent();
    const omodel = new Info();
    const [registros, setRegistros] = useState(null);
    const { getRol } = useToken();
    const buscarSrv = new FuncionarioService();
    const [item, setItem] = useState(filtro[0])
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers: registros, omodel, generic, errors: null, control: null, permss, id: null });

    useEffect(() => {
        loadLazy();
    }, [lazyParams]);

    const loadLazy = (_filtro = null) => {
        setLoading(true);

        let _lazyParams = lazyParams;
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        _lazyParams.filtro = _filtro || item?.cat_id || 'todos';
        buscarSrv.listado({ lazyEvent: JSON.stringify(_lazyParams) }, opcion).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido algún inconveniente, por favor intente nuevamente más tarde', life: 3000 });
        });
    }

    const seleccionar = (data) => {
        confirmDialog({
            message: '¿Está seguro de seleccionar la información?',
            header: 'Confirmación de selección',
            icon: 'pi pi-exclamation-triangle',
            accept: () => seleccion(data)
        });
    };

    const acciones = (rowData) => {
        return (
            <div className="actions">
                {permss?.consultar && rowData?.generado === false &&
                    <Button icon="pi pi-check" title='Seleccionar' className="p-button-rounded p-button-success mr-2" size="small" onClick={() => seleccionar(rowData)} />}
            </div>
        );
    }

    const filtrar = (value) => {
        setItem(value);
        loadLazy(value.cat_id);
    }

    return (
        <>
            <div className="card flex justify-content-center">
                <div className="flex flex-row gap-3">
                    {filtro.map((_opcion) => {
                        return (
                            <div key={_opcion.cat_id} className="flex align-items-center">
                                <RadioButton
                                    inputId={_opcion.cat_id}
                                    name="category"
                                    value={_opcion}
                                    onChange={(e) => filtrar(e.value)}
                                    checked={item?.cat_id === _opcion.cat_id}
                                />
                                <label htmlFor={_opcion.cat_id} className="ml-2">
                                    {_opcion.nombre}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
            {table({ action5: acciones, catalogos: filtro })}
        </>
    )
}
